import { useApiGetQuery, useApiMutation } from 'utils/queryClient'

export const configurationsQueryKey = ['configurations']
export const configurationQueryKey = id => ['configurations', String(id)]

export const useConfigurations = (options = {}) =>
  useApiGetQuery({
    defaultValue: [],
    endpoint: '/configurations',
    queryKey: configurationsQueryKey,
    options,
  })

export const useConfiguration = (id, options = {}) =>
  useApiGetQuery({
    endpoint: `/configurations/${id}`,
    queryKey: configurationQueryKey(id),
    options: {
      enabled: Boolean(id),
      ...options,
    },
  })

export const useCreateConfiguration = (options = {}) =>
  useApiMutation('/configurations', 'post', options)

export const useUpdateConfiguration = (id, options = {}) =>
  useApiMutation(`/configurations/${id}`, 'patch', options)

export const usePublishConfiguration = (id, options = {}) =>
  useApiMutation(`/configurations/${id}/publish`, 'post', options)

export const useCreateConfigurationDrive = (id, options = {}) =>
  useApiMutation(`/configurations/${id}/drives`, 'post', options)

export const useUpdateConfigurationDrive = (id, driveId, options = {}) =>
  useApiMutation(`/configurations/${id}/drives/${driveId}`, 'patch', options)

export const useDeleteConfigurationDrive = (id, driveId, options = {}) =>
  useApiMutation(`/configurations/${id}/drives/${driveId}`, 'delete', options)
